'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Foerderung = require('../entity').Foerderung;

module.exports = function (connection) {
  return {
    byFoerderkennzeichenEquals: function byFoerderkennzeichenEquals(foerderkennzeichen, additionalParams) {
      return templates.searchTemplate(connection)(Foerderung, 'byFoerderkennzeichenEquals', 'foerderkennzeichen')(foerderkennzeichen, additionalParams);
    },
    byFoerderkennzeichenLike: function byFoerderkennzeichenLike(foerderkennzeichen, additionalParams) {
      return templates.searchTemplate(connection)(Foerderung, 'byFoerderkennzeichenLike', 'foerderkennzeichen')(foerderkennzeichen, additionalParams);
    },
    byMittelgeberEquals: function byMittelgeberEquals(mittelgeber, additionalParams) {
      return templates.searchTemplate(connection)(Foerderung, 'byMittelgeberEquals', 'mittelgeber')(mittelgeber, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Foerderung, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Foerderung, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('foerderung')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/foerderung.js
// module id = PRKI
// module chunks = 0